export const ageRanges = [
  { label: "0 a 5 años", value: "0-5" },
  { label: "6 a 11 años", value: "6-11" },
  { label: "12 a 17 años", value: "12-17" },
  { label: "18 a 29 años", value: "18-29" },
  { label: "30 a 59 años", value: "30-59" },
  { label: "60 años y más", value: "60+" }
]

export const AGE_RANGES_LABELS = {
  zeroToFive: "0-5",
  sixToEleven: "6-11",
  twelveToSeventeen: "12-17",
  eightTeenToTwentyNine: "18-29",
  thirtyToFiftyNine: "30-59",
  moreThanSixty: "60+"
}
